import { z } from 'zod';
import { IconSchema } from '../setting/icon-setting';
import { ShadowSettingKeySchema } from '../setting/shadow-setting';
import { TransparencySettingSchema } from '../setting/transparency-setting';
import { TipTapContentSchema } from '../tiptap-content.schema';
import { BasicAnimationSetSchema } from './animations';
import { BasePinComponentSchema, BasePinComponentSettingsSchema } from './base-pin-component';

export const AudioFillTypeSchema = z.enum(['ICON', 'IMAGE', 'TEXT']);
export type AudioFillType = z.infer<typeof AudioFillTypeSchema>;

export const AudioExpandDirectionSchema = z.enum(['AUTO', 'LEFT_DOWN', 'LEFT_UP', 'RIGHT_DOWN', 'RIGHT_UP']);
export type AudioExpandDirection = z.infer<typeof AudioExpandDirectionSchema>;

export const AudioIconSchema = IconSchema;
export type AudioIcon = z.infer<typeof AudioIconSchema>;

export const AudioImageSchema = z.object({
  name: z.string(),
  url: z.string(),
});
export type AudioImage = z.infer<typeof AudioImageSchema>;

export const AudioPinComponentPinThemeSettingsSchema = z.object({
  backgroundColor: z.string().optional(),
  innerColor: z.string().optional(),
  contentBackgroundColor: z.string().optional(),
  contentTextColor: z.string().optional(),
  contentBorderColor: z.string().optional(),
  borderSize: z.number().optional(),
  borderColor: z.string().optional(),
  borderRadius: z.number().optional(),
  borderColorProgress: z.string().optional(),
  shadow: ShadowSettingKeySchema,
  transparency: TransparencySettingSchema,
});
export type AudioPinComponentPinThemeSettings = z.infer<typeof AudioPinComponentPinThemeSettingsSchema>;

const AudioSettingsSchema = BasePinComponentSettingsSchema.merge(
  AudioPinComponentPinThemeSettingsSchema.merge(
    z.object({
      fillType: AudioFillTypeSchema,
      iconFill: AudioIconSchema,
      imageFill: AudioImageSchema,
      expandDirection: AudioExpandDirectionSchema,
      textFill: z.string(),
      title: TipTapContentSchema,
      body: TipTapContentSchema,
      showBody: z.boolean(),
      audioUrl: z.string().url().optional(),
      loop: z.boolean().default(false),
      startTime: z.number().optional(),
      endTime: z.number().optional(),
      volume: z.number().min(0).max(1).default(1),
      animations: BasicAnimationSetSchema.optional(),
    })
  )
);
export type AudioSettings = z.infer<typeof AudioSettingsSchema>;

export const AudioPinComponentTypeSchema = z.literal('AUDIO');

export const AudioPinComponentSchema = BasePinComponentSchema.merge(
  z.object({
    type: AudioPinComponentTypeSchema,
    settings: AudioSettingsSchema,
  })
);
